import { InputHTMLAttributes } from 'react'
import { Field } from 'react-final-form'
import styles from './Engine.module.css'
import { t } from 'i18next'
import ThemePicDelivery from '../../assets/images/engine/theme_pic_delivery.png'
import ThemePicCompany from '../../assets/images/engine/theme_pic_company.png'
import ThemePicNews from '../../assets/images/engine/theme_pic_news.png'
import ThemePicTapas from '../../assets/images/engine/theme_pic_tapas.png'
import ThemePicNews3D from '../../assets/images/engine/theme_pic_news3d.jpg'
import ThemePicStore3D from '../../assets/images/engine/theme_pic_store3d.jpg'
import ThemePicCity3D from '../../assets/images/engine/theme_pic_city3d.jpg'
import ThemePicNature3D from '../../assets/images/engine/theme_pic_nature3d.jpg'
import ThemePicAi from '../../assets/images/engine/theme_pic_ai.png'
import ThemePicPlain from '../../assets/images/engine/theme_pic_plain.png'
import { JSONSafeParse } from './EngineGoalsAndTaskParser'

export const getLanguageOptions = () => {
  return [
    {
      label: t('engine.languages.english', 'English'),
      value: 'English',
    },
    {
      label: t('engine.languages.finnish', 'Finnish'),
      value: 'Finnish',
    },
    {
      label: t('engine.languages.portuguese', 'Portuguese'),
      value: 'Portuguese',
    },
    {
      label: t('engine.languages.dutch', 'Dutch'),
      value: 'Dutch',
    },
    {
      label: t('engine.languages.swedish', 'Swedish'),
      value: 'Swedish',
    },
    {
      label: t('engine.languages.spanish', 'Spanish'),
      value: 'Spanish',
    },
    {
      label: t('engine.languages.german', 'Deutch'),
      value: 'Deutch',
    },
    {
      label: t('engine.languages.norwegian', 'Norwegian'),
      value: 'Norwegian',
    },
  ]
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string
}

export const FileField = ({ name, ...props }: Props) => (
  <Field<FileList> name={name}>
    {({ input: { value, onChange, ...input } }) => (
      <input
        className={styles.fileInput}
        {...input}
        type='file'
        onChange={({ target }) => onChange(target.files)} // instead of the default target.value
        {...props}
      />
    )}
  </Field>
)

export type SelectionOptions = {
  plot_lines: string[]
  image_urls: string[]
}

export type LearningGoal = {
  id: number
  title: string
  text: string
}

export type EngineRunState = {
  fileUploaded: boolean
  matchPairsCreated: boolean
  multiChoiceCreated: boolean
  checkBoxCreated: boolean
  missingWordCreated: boolean
  creativeCreated: boolean
  rawGameCreated: boolean
  previewRounds: string[] | null
  gameBoardUrls: string[] | null
  selectedGameBoardUrl: string | null
  finalGameCreated: boolean
  storyLineCreated: boolean
  gameBoardAttached: boolean
  allReady: boolean
  error: string | null
  usage: { prompt: number; completion: number; total: number }
  latestSubContent: string | undefined
}

export type EngineRunStateItem = keyof EngineRunState

export enum EngineRunStateOrder {
  'fileUploaded' = 0,
  'matchPairsCreated' = 1,
  'multiChoiceCreated' = 2,
  'checkBoxCreated' = 3,
  'missingWordCreated' = 4,
  'creativeCreated' = 5,
  'rawGameCreated' = 6,
  'previewRounds' = 7,
  'gameBoardUrls' = 8,
  'selectedGameBoardUrl' = 9,
  'finalGameCreated' = 10,
  'storyLineCreated' = 11,
  'gameBoardAttached' = 12,
  'allReady' = 13,
  'error' = 14,
  'usage' = 15,
  'latestSubContent' = 16,
}

export const getRunState = (
  content: string,
  gameCreated: boolean,
  setShouldPoll: (shouldPoll: boolean) => void,
): Partial<EngineRunState> => {
  let previewRounds: string[] | null = null
  let gameBoardUrls: string[] | null = null
  let selectedGameBoardUrl: string | null = null
  let latestSubContent: string | undefined = undefined

  if (content.includes('START_PREVIEW_CONTENT')) {
    //let round = 0
    let allPreviewsHaveEnding = false
    if (!previewRounds) previewRounds = []
    if (content.includes('START_PREVIEW_CONTENT')) {
      allPreviewsHaveEnding = content.indexOf('END_PREVIEW_CONTENT') > -1
      const contentEnd =
        content.indexOf('END_PREVIEW_CONTENT') > -1 ? content.indexOf('END_PREVIEW_CONTENT') : content.length - 1

      const thePreviewContent = content.substring(
        content.indexOf('START_PREVIEW_CONTENT') + 'START_PREVIEW_CONTENT'.length,
        contentEnd,
      )
      previewRounds.push(thePreviewContent)
      //round++
    }
    if (allPreviewsHaveEnding) {
      setShouldPoll(false)
      latestSubContent = content
        .substring(content.lastIndexOf('```'), content.lastIndexOf('END_PREVIEW_CONTENT'))
        .replaceAll('#', '')
        .replaceAll('```', '')
        .replaceAll('JSON', '')
        .replaceAll('**', '')
        .replaceAll('START_PREVIEW_CONTENT', '')
        .replaceAll(/\bslotid\s*\d+\b/gi, '')
        .replace(/\[.*?\]/g, '')
        .replace(/【.*?】/g, '')
    }
  }
  if (content.includes('GAME_BOARD_URL')) {
    //let round = 1
    if (!gameBoardUrls) gameBoardUrls = []
    if (content.includes('GAME_BOARD_URL')) {
      if (content.includes('GAME_BOARD_URL_END') && content.includes('/engine_img')) {
        const ending =
          content.indexOf('GAME_BOARD_URL_END') < content.indexOf('/engine_img')
            ? content.length
            : content.indexOf('GAME_BOARD_URL_END')
        let gameBoardUrl = content.substring(content.indexOf('/engine_img'), ending).trim()
        gameBoardUrl = `${process.env.REACT_APP_ENGINE_BACKEND}${gameBoardUrl}`.replaceAll(
          'https://seppo-proxy.herokuapp.com/',
          '',
        )
        console.log(content)
        console.log(content.indexOf('/engine_img'))
        console.log(content.indexOf('GAME_BOARD_URL_END'))
        console.log('BOARL URL:' + gameBoardUrl)
        gameBoardUrls.push(gameBoardUrl)
      } else {
        gameBoardUrls = []
      }
      //round++
    }
  }
  if (content.includes('SELECTED_GAME_BOARD_URL')) {
    selectedGameBoardUrl = content
      .substring(
        content.indexOf('SELECTED_GAME_BOARD_URL') + 'SELECTED_GAME_BOARD_URL'.length,
        content.indexOf('SELECTED_GAME_BOARD_URL_END'),
      )
      .trim()
    selectedGameBoardUrl = `${process.env.REACT_APP_ENGINE_BACKEND}${selectedGameBoardUrl}`.replaceAll(
      'https://seppo-proxy.herokuapp.com/',
      '',
    )
  }
  let usage
  if (content.includes('THREAD_USAGE_START')) {
    usage = JSON.parse(
      content.substring(content.lastIndexOf('{"prompt"'), content.lastIndexOf('THREAD_USAGE_END') - 1).trim(),
    )
  }
  return {
    fileUploaded: content.includes('Material File Id '),
    matchPairsCreated: true, // content.includes('Match pairs tasks created'),
    multiChoiceCreated: true, // content.includes('Multichoice tasks created'),
    checkBoxCreated: true, // content.includes('Checkbox tasks created'),
    missingWordCreated: true, // content.includes('Missing word tasks created'),
    creativeCreated: true, // content.includes('Creative tasks created'),
    rawGameCreated: true, // content.includes('Game created'),
    previewRounds: previewRounds,
    gameBoardUrls: gameBoardUrls,
    selectedGameBoardUrl: selectedGameBoardUrl,
    finalGameCreated: content.includes('SELECTED 12 TASKS'),
    storyLineCreated: content.includes('SELECTED 12 TASKS'),
    gameBoardAttached: content.includes('SELECTED 12 TASKS'),
    allReady: gameCreated || content.includes('Game created true'),
    usage,
    latestSubContent,
  }
}

export const INSTRUCTIONS_DEFAULT = `<ol>
<li><strong>Name your game</strong><br/>
Give your game a title. 
<br/><br/>
<li><strong>Select game language</strong><br/>
Decide the language of your game.
<br/><br/>
<li><strong>Choose a theme</strong><br/>
Select a theme to match your material. Whether it's about healthcare training, employee onboarding, professional development, or other teaching material, our themes adapt seamlessly to a wide range of content.
<br/><br/>
<li><strong>Describe game target group</strong><br/>
With a few words describe the learners/players. For example:<br/>
<ul>
<li>A group of 15 year old children
<li>Young urban adults
<li>Blue collar construction professionals
</ul>
<br/>
<li><strong>Upload your material</strong><br/>
Add your PDF, Word document, or PowerPoint, and let Seppo do the rest! In just 10 minutes, your content will turn into a game with 10-16 ready-to-play tasks.
</ol>
<br/>
Once your game is generated, it's fully editable! Adjust tasks, fine-tune details, and make it your own before playing! 🚀`

export type ThemeDataItem = {
  name: string
  value: string
  description: string
  focusText?: string
  imageUrl: string
  taskCount: number
}

export const BASE_TASK_COUNT = 12

export const getThemesData = (): ThemeDataItem[] => {
  return [
    {
      name: t('engine.themes.fully_ai', 'Fully AI generated'),
      value: 'random',
      description: t(
        'engine.themes.fully_ai_description',
        'Let SAIGE analyse your material and suggest three unique game narratives tailored to your content.',
      ),
      imageUrl: ThemePicAi,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.plain_tasks', 'Plain tasks'),
      value: 'plain',
      description: t(
        'engine.themes.plain_tasks_description',
        'Get only the tasks created by AI, leaving you to customize the look and feel of the game yourself.',
      ),
      imageUrl: ThemePicPlain,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.news_desk', 'News Desk'),
      value: 'news_desk',
      description: t(
        'engine.themes.news_desk_description',
        'A newsroom-themed game where players act as journalists, creating broadcasts and completing tasks as part of a news team.',
      ),
      focusText: t('engine.themes.news_desk_focus', 'Strategy, communication, teamwork, customer service.'),
      imageUrl: ThemePicNews,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.tapas_fiesta', 'Tapas Fiesta'),
      value: 'tapas_fiesta',
      description: t(
        'engine.themes.tapas_fiesta_description',
        'A festive-themed game encouraging collaboration and role-playing around a shared celebration.',
      ),
      focusText: t(
        'engine.themes.tapas_fiesta_focus',
        'Teamwork, collaboration, customer service, and cultural awareness.',
      ),
      imageUrl: ThemePicTapas,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.delivery', 'Delivery Agents'),
      value: 'delivery',
      description: t(
        'engine.themes.delivery_description',
        'A logistics-themed game focusing on learning through challenges in a transportation journey.',
      ),
      focusText: t('engine.themes.delivery_focus', 'Problem-solving, strategy, customer service, and efficiency.'),
      imageUrl: ThemePicDelivery,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.company', 'Company Triathlon'),
      value: 'triathlon',
      description: t('engine.themes.company_description', 'A sporty game designed for strategy and value training.'),
      focusText: t('engine.themes.company_focus', 'Strategy, values, leadership, and team dynamics.'),
      imageUrl: ThemePicCompany,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.3d_news', '3D News Desk'),
      value: 'news3D',
      description: t(
        'engine.themes.3d_news_description',
        'Players dive into the buzz of a news studio, creating broadcasts, tackling challenges and learning in a fun and creative way.',
      ),
      focusText: t('engine.themes.3d_news_focus', 'Communication, strategy, teamwork, and adaptability.'),
      imageUrl: ThemePicNews3D,
      taskCount: BASE_TASK_COUNT,
    },
    {
      name: t('engine.themes.3d_nature', '3D Nature'),
      value: 'nature3D',
      description: t(
        'engine.themes.3d_nature_description',
        'Embark on a magical hike where players explore nature, overcoming obstacles and discovering hidden wonders.',
      ),
      focusText: t('engine.themes.3d_nature_focus', 'Exploration, resilience, problem-solving, communication.'),
      imageUrl: ThemePicNature3D,
      taskCount: 17,
    },
    {
      name: t('engine.themes.3d_esg', '3D City'),
      value: 'esg3D',
      description: t(
        'engine.themes.3d_esg_description',
        'Let your players step into a medieval city, tackling tasks to build a thriving community.',
      ),
      focusText: t('engine.themes.3d_esg_focus', 'Teamwork, problem-solving, leadership, and sustainability.'),
      imageUrl: ThemePicCity3D,
      taskCount: 17,
    },
    {
      name: t('engine.themes.3d_shop', '3D Shop'),
      value: 'shop3D',
      description: t(
        'engine.themes.3d_shop_description',
        'In a lively shop, players walk through various challenges to optimize operations and customer service.',
      ),
      focusText: t('engine.themes.3d_shop_focus', 'Efficiency, safety, customer service, teamwork.'),
      imageUrl: ThemePicStore3D,
      taskCount: 15,
    },
  ]
}

export enum READY_PROMPT {
  'CONTINUE' = 'CONTINUE',
  'PROVIDE_MISSING_TASKS' = 'PROVIDE_MISSING_TASKS',
  'MORE_STORY' = 'MORE_STORY',
  'FIX_MISSING_WORDS' = 'FIX_MISSING_WORDS',
  'CHECK_ALL_TASKS' = 'CHECK_ALL_TASKS',
  'CHECK_SPECIFIC_TASK_TYPES' = 'CHECK_SPECIFIC_TASK_TYPES',
  //'CHECK_TARGET_GROUP' = 'CHECK_TARGET_GROUP',
  'GET_TASKS' = 'GET_TASKS',
  'PROVIDE_MISSING_READY_TASKS' = 'PROVIDE_MISSING_READY_TASKS',
  'FULL_READY_TASKS' = 'FULL_READY_TASKS',
}

type ReadyPrompt = {
  title: string
  displayText?: string
  prompt: string
  hideFromList?: boolean
}

export const READY_PROMPTS: { [K in keyof typeof READY_PROMPT]: ReadyPrompt } = {
  GET_TASKS: {
    title: 'Proceed to task generation with focus on these learning goals',
    prompt: 'Please generate the tasks. The main focus of the game should be on the following learning goals:',
    hideFromList: true,
  },
  CONTINUE: { title: 'Continue please', prompt: 'Yes proceed please' },
  PROVIDE_MISSING_TASKS: {
    title: 'Please provide more tasks',
    prompt: 'Please provide also the missing tasks that you have not provided yet to reach a minimum of 14 tasks.',
  },
  PROVIDE_MISSING_READY_TASKS: {
    title: 'Please provide more tasks',
    prompt: 'Please parse also the rest of the ready made tasks from the document.',
    hideFromList: true,
  },
  FULL_READY_TASKS: {
    title: 'Do not shorten the task descriptions/questions',
    hideFromList: true,
    prompt: `Do not shorten the task descriptions/questions. For some or all of the tasks there might be separate task description and then actual task/question. 
    If so, please include them both in the question field of the JSON so that the description is first and wrap both the description and question parts inside their own <p></p> tags.
    Please do not shorten the task descriptions. You should include them in full starting from the beginning of the description until the options/ways to answer are described.`,
  },
  MORE_STORY: {
    title: 'Elaborate story parts',
    prompt: 'Please ensure that all tasks have the story part and elaborate the story a bit more',
  },
  FIX_MISSING_WORDS: {
    title: 'Revise Missing word tasks',
    prompt:
      'Please revise the missing word tasks that you provided. Check that they are structured according to the specification in the guidelines document.',
  },
  CHECK_ALL_TASKS: {
    title: 'Tasks are missing from the preview',
    hideFromList: true,
    prompt:
      'Check the guidance document for each task type and compare to what you have provided. Are the slots correctly in Missing word tasks and are the json field names as they should be in all task types. Revise and provide the tasks again, please.',
  },
  CHECK_SPECIFIC_TASK_TYPES: {
    title: 'Yes, Revise those tasks!',
    displayText: 'Yes, revise those tasks!',
    hideFromList: true,
    prompt:
      "Check and understand the JSON formatting specification CAREFULLY from the guidance document in your vector store for each task type. Especially check the options and points arrays. Also for Missing word and Order items task types, check that the question text contains the SLOT1, SLOT2 etc placeholders. Focus on tasks with these slotId's or types:REPLACE_THIS . Compare to what you have provided. Is the content of the provided json according to specification in all task types. Revise and provide the fixed tasks again, please. Also remember to not include comments within the JSON.",
  },
}

const escapeHtml = (str: string): string => {
  return str.replace(/[&<>"']/g, (ch) => {
    switch (ch) {
      case '&':
        return '&amp;'
      case '<':
        return '&lt;'
      case '>':
        return '&gt;'
      case '"':
        return '&quot;'
      case "'":
        return '&#39;'
      default:
        return ch
    }
  })
}

const unescapeJsonString = (raw: string): string => {
  // Turn a JSON-string *contents* into a real JS string (handles \" \\n etc.)
  try {
    return JSONSafeParse(`"${raw}"`)
  } catch {
    return raw
  }
}

const extractFallback = (s: string): { name?: string; question?: string } => {
  // No /s flag needed:
  const nameM = /"name"\s*:\s*"((?:[^"\\]|\\[\s\S])*)"/.exec(s)
  const qM = /"question"\s*:\s*"((?:[^"\\]|\\[\s\S])*)"/.exec(s)

  return {
    name: nameM ? unescapeJsonString(nameM[1]) : undefined,
    question: qM ? unescapeJsonString(qM[1]) : undefined,
  }
}

export const transformSnippets = (text: string, stringToEndAt = '<br'): string => {
  const codeblockRe = /```(?:json)?\s*([\s\S]*?)\s*```/g
  const endIndex = text.indexOf(stringToEndAt, 100)
  console.log(endIndex)
  const textToModify = endIndex < 0 ? text : text.substring(0, endIndex)
  return textToModify.replace(codeblockRe, (full, body: string) => {
    let name: unknown
    let question: unknown

    // Try strict JSON first
    try {
      let jsonText = body.trim().replaceAll('<br/>', '')
      if (jsonText[jsonText.length - 1] === ']') jsonText = jsonText.substring(0, jsonText.length - 1)
      if (jsonText[jsonText.length - 1] !== '}') jsonText += '}'
      jsonText = jsonText.replace('}}', '}')
      const obj = JSONSafeParse(jsonText)
      name = (obj as any)?.name
      question = (obj as any)?.question
    } catch {
      // Fall back to regex extraction if JSON.parse fails
      const fb = extractFallback(body)
      name = fb.name
      question = fb.question
    }

    if (typeof name !== 'string' || typeof question !== 'string' || !name || !question) {
      // Couldn’t safely extract both; keep the original code block
      return full
    }

    return `<strong>${escapeHtml(name)}</strong><br/>\n${escapeHtml(question)}`
  })
}

export const transformTextToHtml = (input: string | number | boolean | null | undefined): string => {
  // Normalize to string safely
  let out = String(input ?? '')

  //Sometimes the title #### strings are not preceeded with whitespace
  out = out.replaceAll('####', '\n####')

  // Normalize all line endings to \n
  out = out.replace(/\r\n/g, '\n')

  // Also, if the text contains escaped newlines ("\\n"), turn them into real newlines
  if (out.includes('\\n')) {
    out = out.replace(/\\n/g, '\n')
  }

  // #### or ### Heading → <h3>...</h3>  (spanning until a double newline)
  out = out.replace(
    /^[ \t]*####?\s?([\s\S]*?)(?=\n{1,}|\Z)/gm,
    (_, title: string) => `<h3>${title.replace(/\n+/g, ' ').trim()}</h3>`,
  )

  // 2) **bold** → <strong>...</strong>
  out = out.replace(/\*\*([\s\S]+?)\*\*/g, '<strong>$1</strong>')

  // 3) Replace double newlines with <br/> (paragraph breaks)
  out = out.replace(/\n{1,}/g, '<br/>')

  // 4) Remove any leftover single newlines (streaming artifacts)
  out = out.replace(/\n/g, '')

  return out
}
